module.exports = __webpack_public_path__ + "img/placeholder.8a971be5.png";